var render, staticRenderFns
import script from "./cache.vue?vue&type=script&lang=js&"
export * from "./cache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fe5d2fbe', component.options)
    } else {
      api.reload('fe5d2fbe', component.options)
    }
    
  }
}
component.options.__file = "src/components/services/cache.vue"
export default component.exports